import { formatDateToDDMMYYYY } from 'src/app/project/shared/date-utils';
import { buildWeeks } from './build-weeks';

export function getDayFormattedTimeframes(from: Date, to: Date): string[] {
  let elements = [];

  const weeks = buildWeeks(from, to);

  weeks.forEach((_week) => {
    const day = _week[0];

    const weekDays = [];

    while (day <= _week[1]) {
      weekDays.push(formatDateToDDMMYYYY(day));

      day.setDate(day.getDate() + 1);
    }

    elements = [...elements, ...weekDays];
  });

  return elements;
}
